import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=aa27f91e&scoped=true&"
import script from "./footBar.vue?vue&type=script&lang=js&"
export * from "./footBar.vue?vue&type=script&lang=js&"
import style0 from "./footBar.vue?vue&type=style&index=0&id=aa27f91e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa27f91e",
  null
  
)

export default component.exports